import React from 'react';
import flagsmith from 'flagsmith';
import { FlagsmithProvider, useFlags } from 'flagsmith/react';

const FLAGSMITH_KEY = process.env.REACT_APP_FLAGSMITH_ENVIRONMENT_KEY || "";

const FeatureFlagProvider = ({ children }) => (
  <FlagsmithProvider
    options={{
      environmentID: FLAGSMITH_KEY,
      cacheFlags: true,
    }}
    flagsmith={flagsmith}
  >
      {children}
  </FlagsmithProvider>
);

export const useEnabledFeatureFlag = (featureName) => {
  const flags = useFlags([featureName]);
  return flags?.[featureName]?.enabled ?? false;
};

export default FeatureFlagProvider;